import { render } from "./App.vue?vue&type=template&id=4894037a&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4894037a&lang=scss&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4894037a"]])

export default __exports__